import { BREAKPOINTS_WIDTHS, useWindowSize } from '@belong/common';
import clsx from 'clsx';
import css from './ErrorMessageBubble.module.css';

export const ERROR_STATES = {
  SHOW_ERROR_MESSAGE: true,
  HIDE_ERROR_MESSAGE: false,
  NO_ERROR_MESSAGE: null,
} as const;

type ErrorMessageBubbleProps = {
  showErrorMessageBubble?: (typeof ERROR_STATES)[keyof typeof ERROR_STATES];
  errorMessage?: string;
  bottomPosition?: string;
  rightPosition?: string;
  inline?: boolean;
  errorClassNames?: string;
  bottomPositionMobile?: string;
  bubbleTriangleClassNames?: string;
  // Not all form layout bottom bars are fixed (e.g. Profile), so we opt out of
  // fixed when bottomPositionMobile is set — see usage inside Form.
  mobileFixed?: boolean;
};

const ErrorMessageBubble = ({
  errorClassNames = '',
  showErrorMessageBubble = null,
  inline = true,
  mobileFixed = true,
  bottomPosition,
  bottomPositionMobile,
  rightPosition,
  errorMessage = 'Let’s complete all required fields!',
  bubbleTriangleClassNames = '',
}: ErrorMessageBubbleProps) => {
  const { width } = useWindowSize();
  const isMobile = width <= BREAKPOINTS_WIDTHS.SM;

  const errorBubbleClassNames = clsx(
    `${errorClassNames}`,
    css.errorMessage,
    inline && css.errorMessageInline,
    mobileFixed && css.errorMessageMobileFixed,
    showErrorMessageBubble === ERROR_STATES.SHOW_ERROR_MESSAGE &&
      css.errorMessageShow,
    showErrorMessageBubble === ERROR_STATES.HIDE_ERROR_MESSAGE &&
      css.errorMessageHide,
  );

  return (
    <div
      className={errorBubbleClassNames}
      style={{
        bottom: isMobile ? bottomPositionMobile : bottomPosition,
        right: rightPosition,
      }}
    >
      <div className={css.errorMessageBubble}>{errorMessage}</div>
      <div
        className={clsx(
          css.errorMessageBubbleTriangle,
          bubbleTriangleClassNames,
        )}
      />
    </div>
  );
};

export default ErrorMessageBubble;
